import classNames from "classnames";
import React from "react";
import {DropdownToggle as BSDropdownToggle} from "react-bootstrap";

import Button from "@/components/button/Button.tsx";
import {DropdownToggleProps} from "@/components/dropdown/subComponents/DropdownToggle/DropdownToggle.types.ts";

// This component has a ts error expected due to the fact that despite the component being able to accept any
// element as a child, it has a hard coded set of props that it is typed to accept even tho everything is passed
// through to the child. We use the child's type to infer the props that can be passed to this custom wrapper and thus ignore
// errors coming from the wrapped toggle component
const DropdownToggle = React.forwardRef(
  ({as = Button, children, className, ...rest}: DropdownToggleProps, ref: React.ForwardedRef<Element>) => {
    return (
      // @ts-expect-error incompatible type assignment
      <BSDropdownToggle
        className={classNames("custom-dropdown-toggle", className)}
        bsPrefix={"custom-dropdown"}
        ref={ref}
        as={as}
        {...rest}
      >
        {children}
      </BSDropdownToggle>
    );
  }
);

DropdownToggle.displayName = "DropdownToggle";
export {DropdownToggle};
